import { floors, leadStatuses, roles } from "./constants";

export const isUserLoggedIn = () => {
    return !!localStorage.getItem("crm_user");
};

export const getUserAuthToken = () => {
    const user = localStorage.getItem("crm_user");
    if (user) {
        const userData = JSON.parse(user);
        return userData.token || null;
    }
    return null;
};

export const getPatientAuthToken = () => {
    return localStorage.getItem("patient_token");
};

export const getUserID = () => {
    const user = localStorage.getItem("crm_user");
    if (user) {
        const userData = JSON.parse(user);
        return userData.id || null;
    }
    return null;
};

export const getFullName = (user) => {
    return user ? user.firstName + (user.lastName ? " " + user.lastName : "") : "";
};

export const getFullName2 = (user) => {
    return user.firstName + (user.lastName ? " " + user.lastName : "") + (user.userName && ` @${user.userName}`);
};

export const getInitials = (name) => {
    return name
        .split(" ")
        .map((n) => n[0])
        .join("")
        .toUpperCase()
        .slice(0, 2);
};

export const getTimePasswed = (mydate) => {
    const now = new Date();
    const diffMs = now - new Date(mydate); // in ms
    const diffSec = Math.floor(diffMs / 1000);
    const diffMin = Math.floor(diffSec / 60);
    const diffHr = Math.floor(diffMin / 60);
    const diffDay = Math.floor(diffHr / 24);
    const diffWeek = Math.floor(diffDay / 7);
    const diffMonth = Math.floor(diffDay / 30);

    let result;
    if (diffMonth >= 1) result = `${diffMonth} month${diffMonth > 1 ? "s" : ""} ago`;
    else if (diffWeek >= 1) result = `${diffWeek} week${diffWeek > 1 ? "s" : ""} ago`;
    else if (diffDay >= 1) result = `${diffDay} day${diffDay > 1 ? "s" : ""} ago`;
    else if (diffHr >= 1) result = `${diffHr} hour${diffHr > 1 ? "s" : ""} ago`;
    else if (diffMin >= 1) result = `${diffMin} minute${diffMin > 1 ? "s" : ""} ago`;
    else result = `just now`;
    return result;
};

export const getStatusName = (status) => {
    return leadStatuses.find((option) => option.value === status)?.label;
};

export const getRoleLabel = (role) => {
    const roleObj = roles.find((option) => option.value === role);
    return roleObj ? roleObj.label : "-";
};

export const getFloorLabel = (floor) => {
    const floorObj = floors.find((option) => option.value === floor);
    return floorObj ? floorObj.label : "-";
};

export const updateFirstLetterToUpperCase = (str) => {
    if (!str) return "";
    return str.charAt(0).toUpperCase() + str.slice(1);
};
